/** @format */

import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  specialistTitle: {
    color: '#F1F1F1',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '26px',
    letterSpacing: '0.169px',
  },
  addNotificationButton: {
    width: '100%',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  row: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: '#202020',
    '&:last-of-type': {
      marginTop: 0,
    },
  },
  tgBotTitle: {
    color: '#FFF',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.131px',
  },
  hintNew: {
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: '0.131px',
  },
  linkNew: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(4, 8),
    borderRadius: '8px',
    background: '#2B2B2B',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(4),
      justifyContent: 'center',
    },
  },
  linkIcon: {
    marginRight: theme.spacing(2),
  },
  actionButtonsContainer: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(6),
    },
  },
  actionButton: {
    width: '48px',
    height: '48px',
    marginRight: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    background: '#202020',
    '&:last-of-type': {
      marginRight: 0,
    },
    [theme.breakpoints.down('md')]: {
      flexGrow: '1',
    },
  },
}));
